import React from "react";
import TableView from "../../../../../Basic/TableView";

var UserDetailTable = function UserDetailTable(props) {
  var solution = props.solution,
      prefix = props.prefix,
      translate = props.translate;
  var columns = [{
    id: "Solution",
    isFilterable: false,
    isSortable: false,
    disableHeaderSort: true,
    Header: translate("SFxAccountSettingsUserDetailTableSolutionTitle"),
    headerStyle: {
      minWidth: 300,
      paddingLeft: "10px"
    },
    style: {
      minWidth: 300,
      paddingLeft: "8px"
    },
    minWidth: 300,
    accessor: function accessor(row) {
      return row.name || "--";
    }
  }, {
    id: "Roles",
    isFilterable: false,
    isSortable: false,
    disableHeaderSort: true,
    Header: translate("SFxAccountSettingsUserDetailTableRolesTitle"),
    headerStyle: {
      minWidth: 300
    },
    style: {
      minWidth: 300
    },
    minWidth: 300,
    Cell: function Cell(_ref) {
      var original = _ref.original;
      var _original$roles = original.roles,
          roles = _original$roles === void 0 ? [] : _original$roles;
      var formateRole = Array.isArray(roles) && roles.length > 0 ? roles.map(function (item) {
        return item.displayName;
      }).join(", ") : "--";
      return /*#__PURE__*/React.createElement("span", null, formateRole);
    }
  }, {
    id: "Subscription",
    isFilterable: false,
    isSortable: false,
    disableHeaderSort: true,
    Header: translate("SFxAccountSettingsUserDetailTableSubscriptionTitle"),
    headerStyle: {
      minWidth: 200
    },
    style: {
      minWidth: 200
    },
    minWidth: 200,
    Cell: function Cell(_ref2) {
      var original = _ref2.original;
      var subscription = original.subscription;
      var formateSubscription = subscription ? "".concat(subscription.licenseTier.toUpperCase(), " ").concat(subscription.expiryDate.split("T")[0]) : "";
      return /*#__PURE__*/React.createElement("span", null, formateSubscription);
    }
  }];
  return /*#__PURE__*/React.createElement(TableView, {
    className: "".concat(prefix, "-solution-table"),
    data: solution,
    pageSize: solution.length,
    columns: columns,
    showPagination: false
  });
};

export default UserDetailTable;